import { AuthCookies } from './authCookieConstants';

/** Read CSRF from document.cookie when API cookies are same-origin (e.g. /api proxy). */
export function readCsrfFromDocumentCookie(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const prefix = `${AuthCookies.csrfCookieName}=`;
  const match = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (!match) {
    return null;
  }

  const value = decodeURIComponent(match.slice(prefix.length));
  return value.length > 0 ? value : null;
}

/**
 * Cookie is shared across tabs and rotated on refresh; prefer it over per-tab sessionStorage.
 * CSRF cookie must use Path=/ (not /api) so document.cookie can read it on SPA routes at /.
 * Refresh cookie may still be scoped to /api; only CSRF needs to be readable here.
 */
export function resolveCsrfToken(storedCsrfToken: string | null): string | null {
  return readCsrfFromDocumentCookie() ?? storedCsrfToken;
}
